import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useAssets } from "../assets/AssetsContext";

import { Link } from "react-router-dom";

function Events() {
  const assets = useAssets();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    AOS.refresh();
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const latestnews = [
    // {
    //   id: 1,
    //   title: "Where innovation meets action. .",
    //   subtitle: "June 17th 2025",
    //   image: assets.innovationthumb,
    //   description:
    //     "Explore upcoming summits, field demos, climate-tech hackathons, and global ESG forums where Accel1 is shaping the future of sustainability. Join us on the ground or online — and be part of the change.",
    // },
    {
      id: 1,
      title:
        "Empower Your Organization in Achieving Gold Standard of Auditable ESG Data with AccelTRACK.",
      subtitle: "April 5th 2024",
      image: assets.eventsthumbline,
      // description:
      //   "As the demand for environmental, social, and governance (ESG) transparency rises, listed companies across industries...",
    },
  ];

  return (
    <div>
      <div className="innerbanner-section-1">
        <div className="relative-2">
          <div className="s2-heading-text">
            <h1 data-aos="zoom-in">Events & Experiences</h1>
            <p data-aos="zoom-in">
              Where innovation meets action. Explore upcoming summits, field
              demos, climate-tech hackathons, and global ESG forums where Accel1
              is shaping the future of sustainability. Join us on the ground or
              online — and be part of the change.
            </p>
          </div>
          <img
            src={assets.careerbanner}
            alt=""
            data-aos="fade-in"
            className="d-d"
          />
          <img
            src={assets.careerbanner2}
            alt=""
            data-aos="fade-in"
            className="m-d"
          />
        </div>
      </div>
      <div className="flagship-bg">
        <div className="wrapper">
          <div class="flagship-heading">
            {/* <h2>Latest Blogs</h2> */}
            {/* <p>
              From drylands to data platforms, our breakthrough initiatives
              showcase how scalable climate engineering is driving real-world
              transformation.
            </p> */}
          </div>
          <div className="blog-sec">
            {latestnews.map((news) => (
              <div key={news.id} className="blog-m-item">
                {/* <Link to={`/event/${news.id}`} onClick={scrollToTop}></Link> */}
                <Link to="" onClick={scrollToTop}>
                  <img src={news.image} alt={news.title} />
                  <div className="blog-content">
                    <h4>{news.title}</h4>
                    <h5>{news.subtitle}</h5>
                    <p>{news.description}</p>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Events;
